<section id="dynamic-category-filter-12345" class="style-dynamic-category-filter-12345 editable">
    <div class="category-page-filter filter-layout-1-container filter-layout-background filter-layout-border-color filter-layout-border-top-left-radius filter-layout-border-top-right-radius filter-layout-border-bottom-left-radius filter-layout-border-bottom-right-radius">
        <div class="filter-header-content">
            @if (category()) {
            <div class="category-name">
                <h1 class="filter-heading-text-size filter-heading-text-color filter-heading-text-font-weight filter-heading-text-transform">
                    {{ category() | titlecase }}
                </h1>
            </div>
            }
            @if (currentAppliedFilters()?.length) {
            <div class="clear-action-btn" (click)="resetAllFilters(availableFilterAttributes())">
                <p class="animated fadeIn filter-clear-btn-text-size filter-clear-btn-text-color filter-clear-btn-text-font-weight filter-clear-btn-text-transform">
                    Clear
                </p>
            </div>
            }
        </div>

        @if (currentAppliedFilters()?.length) {
        <div class="selected-filter-content">
            <ul class="filter-chips-list">
                @for (currentAppliedFilter of currentAppliedFilters(); track currentAppliedFilter.filter?.value) {
                <li class="filter-chip-item filter-chip-border-color filter-chip-background filter-chip-border-radius chip-border-top-left-radius chip-border-top-right-radius chip-border-bottom-left-radius chip-border-bottom-right-radius">
                    <div [title]="currentAppliedFilter?.filter?.value" class="filter-chip-text-size filter-chip-text-color filter-chip-text-font-weight filter-chip-text-transform">
                        {{ currentAppliedFilter?.filter?.value }}
                        <span class="filter-count"> ({{ currentAppliedFilter?.filter?.doc_count }}) </span>
                    </div>

                    <div class="clear-chip-item filter-chip-text-color" (click)="updateFilter(currentAppliedFilter.filter, availableFilterAttributes())">
                        &times;
                    </div>
                </li>
                }
            </ul>
        </div>
        }
        @if (availableFilterAttributes()?.length) {
        <div class="facet-container">
            @for (availableAttribute of availableFilterAttributes(); track availableAttribute.label; let i = $index) {
            <ul>
                <div class="facet-container-header" (click)="
                downArrowIndexSignal() && downArrowIndexSignal().includes(i)
                  ? openFilterDropdown(i)
                  : upArrowIndexSignal() && upArrowIndexSignal().includes(i)
                    ? closeFilterDropdown(i)
                    : null
              ">
                    <h2 class="facet-label-text-size facet-label-text-color facet-label-text-font-weight facet-label-text-transform">
                        {{ availableAttribute?.label }}
                    </h2>
                    @if (upArrowIndexSignal()?.includes(i)) {
                    <div class="facet-arrow-up facet-arrow-up-color"></div>
                    }
                    @if (downArrowIndexSignal()?.includes(i)) {
                    <div class="facet-arrow-down facet-arrow-down-color"></div>
                    }
                </div>

                @if (upArrowIndexSignal()?.includes(i)) {
                @for (filter of availableAttribute?.filters; track filter.value + '_' + $index) {
                <li class="filter-option-item animated fadeIn">
                    <div class="filter-option-selection">
                        <label class="filter-option-value">
                            <div class="check-mark-container check-box-background check-mark-border-color check-box-border-top-left-radius check-box-border-top-right-radius check-box-border-bottom-left-radius check-box-border-bottom-right-radius" [ngClass]="{
                          'filter-option-border-color-active filter-option-background-active': filter.checked,
                        }">
                                @if (filter.checked) {
                                <span class="check-mark-icon check-mark-icon-color" [ngClass]="{
                              'check-mark-icon-color-active': filter.checked,
                            }">&check;</span>
                                }
                            </div>
                            <div class="filter-option-text-size filter-option-text-color filter-option-value-border-color filter-option-font-weight filter-option-text-transform">
                                {{ filter?.value }}
                                <span class="filter-count">({{ filter?.doc_count }})</span>
                            </div>
                            <input class="filter-option-checkbox check-box-background check-box-hover-color" type="checkbox" [value]="filter?.value" [checked]="filter.checked" (change)="updateFilter(filter, availableFilterAttributes())" />
                        </label>
                    </div>
                </li>
                }
                }
            </ul>
            }
        </div>
        }
    </div>
</section>